export const IndicatorType = ({ props }) => ([
  { text: 'Anzahl', value: 'Anzahl' },
  { text: 'Multiplikatives Hazard-Modell (O/E)', value: 'HazOdE' },
  { text: 'Multiplikatives Hazard-Modell (O-E)', value: 'HazOmE' },
  { text: 'Multiplikatives Hazard-Modell E', value: 'HazE' },
  { text: 'Multiplikatives Hazard-Modell O', value: 'HazO' },
  { text: 'Logistische Regression (O/E)', value: 'LogRegOdE' },
  { text: 'Logistische Regression (O-E)', value: 'LogRegOmE' },
  { text: 'Logistische Regression E', value: 'LogRegE' },
  { text: 'Logistische Regression O', value: 'LogRegO' },
  { text: 'Kontinuierlich - Mittelwert', value: 'KontMittelwert' },
  { text: 'Kontinuierlich - risikoadjustiert', value: 'KontRisiko' },
  { text: 'Median', value: 'Median' },
  { text: 'Mittelwert', value: 'Mittelwert' },
  { text: 'Patientenbefragung - QI', value: 'PatBefQI' },
  { text: 'Patientenbefragung - Merkmal', value: 'PatBefMerkmal' },
  { text: 'Patientenbefragung - Risikoadjustierter QI', value: 'PatBefRiAdjQi' },
  { text: 'Patientenbefragung - Risikoadjustiertes Merkmal', value: 'PatBefRiAdjMerkmal' },
  { text: 'Poisson Regression (O/E)', value: 'PoiRegOdE' },
  { text: 'Poisson Regression (O-E)', value: 'PoiRegOmE' },
  { text: 'Poisson Regression E', value: 'PoiRegE' },
  { text: 'Poisson Regression O', value: 'PoiRegO' },
  { text: 'Quote', value: 'Quote' },
  { text: 'Ratenbasiert', value: 'Rate' },
  { text: 'Sentinel Event', value: 'Sentinel' },
])
